import {
  Component,
  Input,
  ContentChildren,
  QueryList,
  AfterContentInit,
} from "@angular/core";
import { WizardSubstepComponent } from "./wizard-substep.component";
@Component({
  selector: "icn-wizard-step",
  templateUrl: "./wizard-step.component.html",
  styleUrls: ["./wizard-step.component.scss"],
  host: {
    "[class.active]": "isCurrent",
  },
})
export class WizardStepComponent implements AfterContentInit {
  @Input()
  icon;

  @Input()
  title = null;

  @Input()
  name;

  @Input()
  description;

  @Input()
  showStepInfo = true;

  @Input()
  isDoneStep = false;

  @Input()
  beforeNextStep: (BeforeNextStepEventHandler) => void = null;

  @ContentChildren(WizardSubstepComponent)
  substeps: QueryList<WizardSubstepComponent>;

  isCurrent: boolean;
  stepIndex: number;

  currentSubstep: WizardSubstepComponent;

  ngAfterContentInit() {
    if (this.substeps.length === 0) {
      throw new Error("Wizard step should have at least one substep");
    }

    this.currentSubstep = this.substeps.first;
    this.currentSubstep.isCurrent = true;

    this.substeps.forEach((substep: WizardSubstepComponent, index: number) => {
      substep.substepIndex = index;
    });
  }

  isBackHidden() {
    if (this.stepIndex === 0 && this.currentSubstep.substepIndex === 0) {
      return true;
    }
    if (this.isDoneStep) {
      return true;
    }

    return false;
  }

  isNextDisabled() {
    if (this.isDoneStep) {
      return true;
    }
    return !this.currentSubstep.canGoNext();
  }

  isNextHidden() {
    return this.isDoneStep;
  }

  get hasNext() {
    return this.currentSubstep !== this.substeps.last;
  }

  get hasBack() {
    return this.currentSubstep !== this.substeps.first;
  }

  next() {
    this.currentSubstep.isCurrent = false;
    this.currentSubstep =
      this.substeps.toArray()[this.currentSubstep.substepIndex + 1];
    this.currentSubstep.isCurrent = true;
  }

  back() {
    this.currentSubstep.isCurrent = false;
    this.currentSubstep =
      this.substeps.toArray()[this.currentSubstep.substepIndex - 1];
    this.currentSubstep.isCurrent = true;
  }

  last() {
    this.currentSubstep.isCurrent = false;
    this.currentSubstep = this.substeps.last;
    this.currentSubstep.isCurrent = true;
  }

  first() {
    this.currentSubstep.isCurrent = false;
    this.currentSubstep = this.substeps.first;
    this.currentSubstep.isCurrent = true;
  }
}
